import { useQuery } from '@tanstack/react-query'
import { leaderboardApi } from '@api/endpoints/leaderboard'
import { LeaderboardParams } from '@api/types/leaderboard'

export function useAdventureLeaderboard(
  adventureId: string | undefined,
  params?: LeaderboardParams
) {
  return useQuery({
    queryKey: ['adventure-leaderboard', adventureId, params],
    queryFn: () => leaderboardApi.getLeaderboard(adventureId!, params),
    enabled: !!adventureId,
    staleTime: 60000, // 1 minute - leaderboards don't change frequently
    refetchOnWindowFocus: false,
  })
}
